// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as CookieUtils$PorterinFeature from "../../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../../domain/repo/AuthRepoManager.mjs";
import * as CustomErrorUtils$PorterinFeature from "../../../../../order-review/domain/helpers/CustomErrorUtils.mjs";

function initialFormState(login_form_input) {
  if (login_form_input !== undefined) {
    return login_form_input;
  } else {
    return {
            mobile: ""
          };
  }
}

function onFormSubmit(output, callbacks, setResponse, set_auth_state, query_params, set_user) {
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  var webTrackingId = CookieUtils$PorterinFeature.webTrackingIdSafely(undefined);
  var form_data = {
    mobile: output.mobile
  };
  Curry._1(set_user, {
        auth_token: undefined,
        mobile: form_data.mobile,
        name: undefined,
        requirement_type: undefined,
        email: undefined,
        whatsapp_consent: undefined
      });
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.checkCustomerExists, webTrackingId, form_data.mobile, query_params);
        }), (function (data) {
          Curry._1(callbacks.notifyOnSuccess, undefined);
          if (data.status === true) {
            return Curry._1(set_auth_state, (function (param) {
                          return /* OtpValidation */2;
                        }));
          } else {
            return Curry._1(set_auth_state, (function (param) {
                          return /* SignupScreen */0;
                        }));
          }
        }), (function (error) {
          var match = CustomErrorUtils$PorterinFeature.getErrorEntity(error);
          var exit = 0;
          if (typeof match === "number" || match.TAG !== /* UnprocessedEntity */1) {
            exit = 1;
          } else {
            Curry._1(setResponse, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.resolveError(error)
                          };
                  }));
          }
          if (exit === 1) {
            Curry._1(setResponse, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.resolveError(error)
                          };
                  }));
          }
          Curry._1(callbacks.notifyOnFailure, error);
        }));
}

export {
  initialFormState ,
  onFormSubmit ,
}
/* CookieUtils-PorterinFeature Not a pure module */
